import {createContext} from 'react';

export const MuteContext = createContext({});
